<div class="slider">
  <div *ngIf="showInputThresholds" class="slider__input-thresholds">
    <input
      type="number"
      [min]="floor"
      name="min"
      [(ngModel)]="minInput"
      [placeholder]="floor"
      (keyup)="onKeyUp($event)"
      (blur)="onUpdateInput($event)"
    />
    <ng-container *ngIf="slider === sliderType.range">
      <span>{{ "product.filter.label.until" | translate }}</span>
      <input
        type="number"
        [max]="ceil"
        name="max"
        [(ngModel)]="maxInput"
        [placeholder]="ceil"
        (keyup)="onKeyUp($event)"
        (blur)="onUpdateInput($event)"
      />
    </ng-container>
  </div>
  <div class="slider__slide">
    <div class="slider__slide-thresholds">
      <a *ngIf="showStepperButtons" class="select-count__button--decrement" (click)="onDecrement()">
        <i class="icon icon--md icon-ui-minus"></i>
      </a>
      <label *ngIf="!showInputThresholds && !showInputSticker">{{ minInput }}</label>

      <ngx-slider
        [value]="min"
        [highValue]="highValue"
        [options]="options"
        (userChangeEnd)="showInputThresholds ? onUpdateSlider($event) : emitValues()"
        (userChange)="!showInputThresholds ? onUpdateSlider($event, false) : null"
      ></ngx-slider>

      <label *ngIf="!showInputThresholds && !showInputSticker">{{ maxInput }}</label>
      <a *ngIf="showStepperButtons" class="select-count__button--increment" (click)="onIncrement()">
        <i class="icon icon--md icon-ui-plus"></i>
      </a>
    </div>

    <air-miles-sticker *ngIf="showInputSticker" [points]="min" size="sm" class="slider__slide-thresholds--sticker"></air-miles-sticker>
  </div>
</div>
